import { render, staticRenderFns } from "./UserGroupFormFields.vue?vue&type=template&id=3674015f"
import script from "./UserGroupFormFields.vue?vue&type=script&lang=js"
export * from "./UserGroupFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports